import React, { useMemo } from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const getUniqueCities = (addresses) => {
  const seen = new Set();
  return addresses.reduce((cities, address) => {
    const city = address?.cityName;
    if (!city || seen.has(city)) return cities;
    seen.add(city);
    cities.push(city);
    return cities;
  }, []);
};

/**
 * Haklai-only copy of the Classic Form 2990 city/street interaction contract.
 * It intentionally shares only the address catalog API, so Classic rendering stays isolated.
 */
const HaklaiAddressAutocomplete = ({
  addresses = [],
  city,
  disabled,
  error,
  helperText,
  label,
  name,
  onChange,
  textFieldWidth = 190,
  value
}) => {
  const options = useMemo(
    () => (
      name === "assetCity"
        ? getUniqueCities(addresses)
        : addresses
          .filter((address) => address?.cityName === city)
          .map((address) => address?.streetName)
          .filter(Boolean)
    ),
    [addresses, city, name]
  );
  const normalizedValue = value == null ? "" : String(value);
  const selectedValue = options.includes(normalizedValue) ? normalizedValue : null;
  const hasHelperText = helperText !== undefined && helperText !== null && helperText !== "";
  const emitChange = (nextValue) => onChange({
    target: {
      name,
      value: nextValue == null ? "" : String(nextValue)
    }
  });

  return (
    <Autocomplete
      blurOnSelect
      disabled={disabled}
      freeSolo
      fullWidth
      inputValue={normalizedValue}
      onInputChange={(event, nextValue, reason) => {
        if (reason === "input" || reason === "clear") emitChange(nextValue);
      }}
      onChange={(event, nextValue) => emitChange(nextValue)}
      openOnFocus
      options={options}
      value={selectedValue}
      style={{ width: `${textFieldWidth}px` }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          FormHelperTextProps={hasHelperText ? {
            style: {
              lineHeight: 1.25,
              maxWidth: `${textFieldWidth}px`,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            title: String(helperText)
          } : undefined}
          helperText={hasHelperText ? helperText : undefined}
          inputProps={{
            ...params.inputProps,
            "aria-label": label
          }}
          size="small"
          variant="outlined"
        />
      )}
    />
  );
};

export default HaklaiAddressAutocomplete;
